import { render, staticRenderFns } from "./DepositInformation.vue?vue&type=template&id=4f1c5a03&scoped=true"
import script from "./DepositInformation.vue?vue&type=script&lang=js"
export * from "./DepositInformation.vue?vue&type=script&lang=js"
import style0 from "./DepositInformation.vue?vue&type=style&index=0&id=4f1c5a03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1c5a03",
  null
  
)

export default component.exports